import React from 'react';

//Componentes
import ViniedoSearchContainer from '../../components/viniedoSearch/ViniedoSearchContainer';

//Estilos
import './SearchViniedos.css';

function SearchViniedos({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        onSearch,
    } = functions;

    const { masters, SearchParameters } = states;

    return (
        <div className="search_viniedos-container">
            <section className="search_viniedos-section">
                <h4>Filtro de Búsqueda</h4>
                <form
                    className="search_viniedos-search_form"
                    onSubmit={handleSubmit(onSearch)}
                >
                    <label className="search_viniedos-label">
                        <span>Viñedo: </span>
                        <input
                            className="search_viniedos-input"
                            type="number"
                            {...register('viniedo')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_viniedos-label">
                        <span>Titular: </span>
                        <input
                            className="search_viniedos-input"
                            type="text"
                            {...register('titular')}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 20) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_viniedos-label">
                        <span>Departamento: </span>
                        <select {...register('departamento')}>
                            <option value={0}>Cualquiera</option>
                            {masters?.Departments?.map((d) => {
                                return (
                                    <option key={d.id} value={d.id}>
                                        {d.nombre.replaceAll('_', ' ')}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                    <label className="search_viniedos-label">
                        <span>Seccional: </span>
                        <input
                            type="number"
                            {...register('seccional')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 2
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_viniedos-label">
                        <span>Padrón: </span>
                        <input
                            className="search_viniedos-input"
                            type="number"
                            {...register('padron')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_viniedos-label">
                        <span>Habilitado: </span>
                        <select {...register('habilitado')}>
                            <option value={1}>SI</option>
                            <option value={0}>NO</option>
                        </select>
                    </label>
                    <div className="search_viniedos-form-footer">
                        <button className="btn btn-primary" type="submit">
                            Buscar
                        </button>
                    </div>
                </form>
            </section>
            {Object.keys(SearchParameters.viniedos).length > 0 && (
                <ViniedoSearchContainer />
            )}
        </div>
    );
}

export default SearchViniedos;
